import {
    CHANGE_AVANZADO_FILTER,
    CHANGE_CARACTERS_ANIMAL,
    CHANGE_CARACTERS_SELECCIONADOS,
    CHANGE_CHIP_SELECCIONADO,
    CHANGE_COLORES_ANIMAL,
    CHANGE_COLORES_SELECCIONADOS,
    CHANGE_EDADES_SELECCIONADAS,
    CHANGE_EMAIL_SUBSCRIPTION,
    CHANGE_ESPECIE_SELECCIONADA,
    CHANGE_ESTADO_SELECCIONADO,
    CHANGE_ESTADO_URGENTE_SELECCIONADO,
    CHANGE_POSTAL_CODE,
    CHANGE_PPP_SELECCIONADO,
    CHANGE_RAZA_SELECCIONADA,
    CHANGE_SEXO_SELECCIONADO,
    CHANGE_TAMANIOS_SELECCIONADOS,
    CHANGE_VACUNA_SELECCIONADA,
    RESET_FILTERS,
    SAVE_EDADES_ANIMAL,
    SAVE_ESTADOS_ANIMAL,
    SAVE_RAZAS,
    SAVE_RAZAS_GATO,
    SAVE_RAZAS_PERRO,
    SAVE_TAMANIOS_ANIMAL,
    SAVE_TIPOS_ENTIDAD
} from '../actions/actionsFilterAnimals';

import PARAMETROS from '../../../config/ParametrosApp.js'

const initialState = {
    emailSubscription: "",
    // razasPerro: [],
    // razas_perro: PARAMETROS.razas_perro || [],
    razasAnimales: {
        perro: [],
        gato: [],
    },
    // razasGato: [],
    // razas_gato: PARAMETROS.razas_gato || [],

    avanzado: false,
    especieSeleccionada: "ambos",
    sexoSeleccionado: "MH",
    tamaniosSeleccionados: [],
    edadesSeleccionadas: [],
    // razasSeleccionadas: [],
    razaSeleccionada: undefined,

    // estadosAnimal: [],
    estadosAnimal: PARAMETROS.estadosAnimal || [],
    estadoAnimalSeleccionado: "",
    tiposEntidad: PARAMETROS.tiposEntidad || [],

    // coloresAnimal: [],
    coloresAnimal: PARAMETROS.coloresAnimal || [],
    coloresAnimalSeleccionados: [],

    // caractersAnimal: [],
    caractersAnimal: PARAMETROS.caractersAnimal || [],
    caractersAnimalSeleccionados: [],

    edadesAnimal: PARAMETROS.edadesAnimal || [],
    tamaniosAnimal: PARAMETROS.tamanosAnimal || [],

    chipSeleccionado: false,
    vacunaSeleccionada: false,
    pppSeleccionado: false,
    estadoUrgenteSeleccionado: false

};

export function reducerFiltersControl(state = initialState, action) {


    switch (action.type) {
        case CHANGE_EMAIL_SUBSCRIPTION:
            return {...state, emailSubscription: action.payload.emailSubscription};
        case CHANGE_POSTAL_CODE:
            return {...state, postalCode: action.payload.postalCode};
        case SAVE_RAZAS:
            return {...state, razasAnimales: {...state.razasAnimales, ...action.payload.razas}};
        // case SAVE_RAZAS_PERRO:
        //     return {...state, razasPerro: action.payload.razasPerro};
        // case SAVE_RAZAS_GATO:
        //     return {...state, razasGato: action.payload.razasGato};
        case SAVE_EDADES_ANIMAL:
            return {...state, edadesAnimal: action.payload.edadesAnimal};
        case SAVE_TAMANIOS_ANIMAL:
            return {...state, tamaniosAnimal: action.payload.tamaniosAnimal};
        case CHANGE_ESPECIE_SELECCIONADA:
            return {...state, especieSeleccionada: action.payload.especieSeleccionada};
        case CHANGE_SEXO_SELECCIONADO:
            return {...state, sexoSeleccionado: action.payload.sexoSeleccionado};
        case CHANGE_TAMANIOS_SELECCIONADOS:
            return {...state, tamaniosSeleccionados: action.payload.tamaniosSeleccionados};
        case CHANGE_EDADES_SELECCIONADAS:
            return {...state, edadesSeleccionadas: action.payload.edadesSeleccionadas};
        case CHANGE_RAZA_SELECCIONADA:
            return {...state, razaSeleccionada: action.payload.razaSeleccionada};
        case CHANGE_AVANZADO_FILTER:
            return {...state, avanzado: action.payload.avanzado};
        case SAVE_ESTADOS_ANIMAL:
            return {
                ...state,
                estadosAnimal: action.payload.estadosAnimal,
                estadoAnimalSeleccionado: (action.payload.estadosAnimal !== undefined && action.payload.estadosAnimal.length !== 0) ? action.payload.estadosAnimal[0].text : ""
            };
        case SAVE_TIPOS_ENTIDAD:
            return {
                ...state,
                tiposEntidad: action.payload.tiposEntidad,
                // estadoAnimalSeleccionado: (action.payload.estadosAnimal !== undefined && action.payload.estadosAnimal.length !== 0) ? action.payload.estadosAnimal[0].text : ""
            };
        case CHANGE_ESTADO_SELECCIONADO:
            return {...state, estadoAnimalSeleccionado: action.payload.estadoAnimalSeleccionado};
        case CHANGE_COLORES_ANIMAL:
            return {...state, coloresAnimal: action.payload.coloresAnimal};
        case CHANGE_COLORES_SELECCIONADOS:
            return {...state, coloresAnimalSeleccionados: action.payload.coloresAnimalSeleccionados};
        case CHANGE_CARACTERS_ANIMAL:
            return {...state, caractersAnimal: action.payload.caractersAnimal};
        case CHANGE_CARACTERS_SELECCIONADOS:
            return {...state, caractersAnimalSeleccionados: action.payload.caractersAnimalSeleccionados};
        case CHANGE_CHIP_SELECCIONADO:
            return {...state, chipSeleccionado: action.payload.chipSeleccionado};
        case CHANGE_ESTADO_URGENTE_SELECCIONADO:
            return {...state, estadoUrgenteSeleccionado: action.payload.estadoUrgenteSeleccionado};
        case CHANGE_VACUNA_SELECCIONADA:
            return {...state, vacunaSeleccionada: action.payload.vacunaSeleccionada};
        case CHANGE_PPP_SELECCIONADO:
            return {...state, pppSeleccionado: action.payload.pppSeleccionado};
        case RESET_FILTERS:
            return {
                ...state,
                // razasPerro: [],
                razasAnimales: {
                    perro: [],
                    gato: [],
                },
                // razasGato: [],
                edadesAnimal: [],
                avanzado: false,
                especieSeleccionada: "ambos",
                sexoSeleccionado: "MH",
                tamaniosSeleccionados: [],
                edadesSeleccionadas: [],
                // razasSeleccionadas: [],
                razaSeleccionada: undefined,

                estadosAnimal: [],
                estadoAnimalSeleccionado: "",

                coloresAnimal: [],
                coloresAnimalSeleccionados: [],

                caractersAnimal: [],
                caractersAnimalSeleccionados: [],

                chipSeleccionado: false,
                vacunaSeleccionada: false,
                pppSeleccionado: false,
                estadoUrgenteSeleccionado: false
            };
        default:
            return state
    }
}